import React from 'react';

const Asterisk = () => (
  <i style={{ color: '#ed1c24', fontSize: '7px' }} className="fa fa-asterisk fa-xs" aria-hidden="true" />
  )
;


export default Asterisk;



// WEBPACK FOOTER //
// ./app/components/Asterisk/index.js